/** Build path with numeric/string id: `/applications/12` */
export function withId(base: string, id: number | string): string {
  return `${base}/${id}`
}
